import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { updateEntityBrandingForm } from 'services/entities/duck';
import EditEntityBrandingForm from 'components/organisms/forms/EditEntityBranding';

class EditEntityBrandingContainer extends Component {
    render() {
        return (
            <EditEntityBrandingForm
                entity={this.props.entity}
                pristine={this.props.pristine}
                dispatch={this.props.dispatch}
                theme={this.props.theme}
                handleSubmit={this.props.handleSubmit.bind(null, updateEntityBrandingForm)}
            />
        );
    }
}

const mapStateToProps = state => ({
    entity: state.entities.entity,
    initialValues: state.entities.entity
});


export default compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'editEntityBranding',
        enableReinitialize: true,
        fields: ['branding.removeLogo']
    })
)(EditEntityBrandingContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/EditEntityBrandingContainer.js